<i-accordion [title]="'courrierFiche.mailInfo' | translate">
  <i-accordion-tab [header]="'courrierFiche.generalInfo' | translate" [showEditBtn]="false" [selected]="true">
    <div class="ms-1">
      <div class="d-flex justify-content-between w-100">
        <div class="w-100">
          <div class="d-flex align-items-center me-4">
            <img src="./assets/img/infos_mail.svg" width="20" height="20" class="img-fluid mb-2 me-4" alt="" />
            <div class="row w-100">
              <div class="col-3">
                <span class="fiche-point-content-info__text">{{ 'type' | translate }}</span>
                @if (courrier?.typeEntrantSortant === 'E') {
                  <p>{{ 'entrant' | translate }}</p>
                }
                @if (courrier?.typeEntrantSortant === 'S') {
                  <p>{{ 'sortant' | translate }}</p>
                }
                @if (courrier?.typeEntrantSortant === 'I') {
                  <p>{{ 'interne' | translate }}</p>
                }
              </div>
              @if (courrier?.nature) {
                <div class="col-3">
                  <span class="fiche-point-content-info__text">{{ 'nature' | translate }}</span>
                  <p>{{ courrier?.nature.description }}</p>
                </div>
              }
              @if (courrier?.source) {
                <div class="col-3">
                  <span class="fiche-point-content-info__text">{{ 'source' | translate }}</span>
                  <p>{{ courrier?.source }}</p>
                </div>
              }
              @if (courrier?.confidentiel) {
                <div class="col-3">
                  <span class="fiche-point-content-info__text">{{ 'privacy' | translate }}</span>
                  <p>{{ 'courrierFiche.confidentialMail' | translate }}</p>
                </div>
              }
              @if (showRefRecommanded && courrier?.referenceRecommande) {
                <div class="col-3">
                  <span class="fiche-point-content-info__text">{{ 'RefRecommended' | translate }}</span>
                  <p>{{ courrier?.referenceRecommande }}</p>
                </div>
              }
              @if (courrier?.bacLabelForInfos) {
                <div class="col-3">
                  <span class="fiche-point-content-info__text">{{ 'courrierFiche.bin' | translate }}</span>
                  <p>{{ courrier?.bacLabelForInfos }}</p>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
    @if (
      courrier?.expediteurFull?.prenom ||
      courrier?.expediteurFull?.nom ||
      courrier?.refExpediteur ||
      (courrier?.expediteurLibre !== null && courrier?.expediteurLibre !== '')
    ) {
      <div class="mt-2 ms-1">
        <div class="d-flex justify-content-between w-100">
          <div class="w-100">
            <div class="d-flex align-items-center me-4">
              <img src="./assets/img/infos_send.svg" width="20" height="20" class="img-fluid mb-2 me-4" alt="" />
              <div class="row w-100">
                @if (courrier?.expediteurFull?.prenom || courrier?.expediteurFull?.nom) {
                  <div class="col-3">
                    <span class="fiche-point-content-info__text">{{ 'sender' | translate }}</span>
                    @if (courrier.expediteurId) {
                      <i
                        class="ms-2 bi bi-box-arrow-in-up-right icon--bold cursor--pointer"
                        [pTooltip]="'courrierFiche.openContactDetails' | translate"
                        (click)="openContactDetails()"></i>
                    }
                    <p [pTooltip]="senderTooltip" tooltipPosition="bottom">
                      <span>{{ courrier?.expediteurFull?.prenom }} {{ courrier?.expediteurFull?.nom }}</span>
                    </p>
                  </div>
                }
                @if (courrier?.refExpediteur) {
                  <div class="col-3">
                    <span class="fiche-point-content-info__text">{{ 'courrierFiche.refSender' | translate }}</span>
                    <p>{{ courrier?.refExpediteur }}</p>
                  </div>
                }
                @if (courrier?.expediteurLibre !== null && courrier?.expediteurLibre !== '') {
                  <div class="col-3">
                    <span class="fiche-point-content-info__text">{{ 'courrierFiche.freeSender' | translate }}</span>
                    <p [innerHtml]="courrier?.expediteurLibre | replaceLineBreaks"></p>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    }
    @if (courrier?.dateEntree || courrier?.dateDocument !== null || courrier?.datePostale !== null || courrier?.dateEcheance !== null) {
      <div class="ms-1 mt-2">
        <div class="d-flex justify-content-between w-100">
          <div class="w-100">
            <div class="d-flex align-items-center me-4">
              <img src="./assets/img/infos_calendar.svg" width="20" height="20" class="img-fluid mb-2 me-4" alt="" />
              <div class="row w-100">
                @if (courrier?.dateEntree) {
                  <div class="col-3">
                    @if (courrier?.typeEntrantSortant && courrier?.typeEntrantSortant !== 'S') {
                      <span class="fiche-point-content-info__text">{{ 'courrierFiche.entryDate' | translate }}</span>
                    }
                    @if (courrier?.typeEntrantSortant && courrier?.typeEntrantSortant === 'S') {
                      <span class="fiche-point-content-info__text">{{ 'courrierFiche.exitDate' | translate }}</span>
                    }
                    <p>{{ courrier?.dateEntree.toString() | momentFormat: 'DD/MM/YYYY' }}</p>
                  </div>
                }
                @if (courrier?.dateDocument) {
                  <div class="col-3">
                    <span class="fiche-point-content-info__text">{{ 'courrierFiche.docDate' | translate }}</span>
                    <p>{{ courrier.dateDocument.toString() | momentFormat: 'DD/MM/YYYY' }}</p>
                  </div>
                }
                @if (courrier?.datePostale) {
                  <div class="col-3">
                    <span class="fiche-point-content-info__text">{{ 'courrierFiche.postalDate' | translate }}</span>
                    <p>{{ courrier?.datePostale.toString() | momentFormat: 'DD/MM/YYYY' }}</p>
                  </div>
                }
                @if (courrier?.dateEcheance) {
                  <div class="col-3">
                    <span class="fiche-point-content-info__text">{{ 'courrierFiche.dueDate' | translate }}</span>
                    <p>{{ courrier?.dateEcheance.toString() | momentFormat: 'DD/MM/YYYY' }}</p>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    }
    @if (courrier?.centreNumLabel) {
      <div class="ms-1 mt-2">
        <div class="d-flex justify-content-between w-100">
          <div class="w-100">
            <div class="d-flex align-items-center me-4">
              <div class="logo__scanner logo__scanner--dark me-4"></div>
              <div class="row w-100">
                <div class="col-12">
                  <span class="fiche-point-content-info__text">{{ 'courrierFiche.scanningCenter' | translate }}</span>
                  <p>{{ courrier?.centreNumLabel }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    }
    @if (courrier?.annexeDiffusee || courrier?.annexeNonScannee || courrier?.annexeNonScanneeNombre) {
      <div class="ms-1 mt-2">
        <div class="d-flex justify-content-between w-100">
          <div class="w-100">
            <div class="d-flex align-items-center me-4">
              <img src="./assets/img/infos_paperclip.svg" width="20" height="20" class="img-fluid mb-2 me-4" alt="" />
              <div class="row w-100">
                @if (courrier?.annexeDiffusee) {
                  <div class="col-3">
                    <span class="fiche-point-content-info__text">{{ 'courrierFiche.publishedAnnex' | translate }}</span>
                    <p>{{ 'global.yes' | translate }}</p>
                  </div>
                }
                @if (courrier?.annexeNonScannee) {
                  <div class="col-3">
                    <span class="fiche-point-content-info__text">{{ 'courrierFiche.noScanAnnex' | translate }}</span>
                    <p>{{ 'global.yes' | translate }}</p>
                  </div>
                }
                @if (courrier?.annexeNonScanneeNombre) {
                  <div class="col-3">
                    <span class="fiche-point-content-info__text">{{ 'courrierFiche.NbrNoScanAnnex' | translate }}</span>
                    <p>{{ courrier?.annexeNonScanneeNombre }}</p>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    }
    @if (configuration?.mails?.hideClassementDossiers === false && (courrier?.classement || courrier?.classeur || courrier?.chemise)) {
      <div class="mt-2 ms-1">
        <div class="d-flex justify-content-between w-100">
          <div class="w-100">
            <div class="d-flex align-items-start me-4">
              <img src="./assets/img/infos_classement.svg" width="20" height="20" class="img-fluid mb-2 me-4 mt-3" alt="" />
              <div class="row w-100">
                @if (courrier?.classementId && courrier?.classementId > 0) {
                  <div class="col-12">
                    <span class="fiche-point-content-info__text">{{ 'courrierFiche.filling' | translate }}</span>
                    <i
                      class="ms-2 bi bi-box-arrow-in-up-right icon--bold cursor--pointer"
                      [pTooltip]="'courrierFiche.openAllMailsWithThisClassificationCodeAndService' | translate"
                      (click)="sendAdvancedSearchInfos(false, false)"></i>
                    <p>{{ courrier?.classement?.code }} {{ courrier?.classement?.description }}</p>
                  </div>
                }
                @if (courrier?.classeur?.description) {
                  <div class="col-12">
                    <span class="fiche-point-content-info__text">{{ 'courrierFiche.filingCabinet' | translate }}</span>
                    <i
                      class="ms-2 bi bi-box-arrow-in-up-right icon--bold cursor--pointer"
                      [pTooltip]="'courrierFiche.openAllMailsWithThisBinderAndService' | translate"
                      (click)="sendAdvancedSearchInfos(true, false)"></i>
                    <p>{{ courrier?.classeur?.description }}</p>
                  </div>
                }
                @if (courrier?.chemise?.description) {
                  <div class="col-12">
                    <span class="fiche-point-content-info__text">{{ 'courrierFiche.folder' | translate }}</span>
                    <i
                      class="ms-2 bi bi-box-arrow-in-up-right icon--bold cursor--pointer"
                      [pTooltip]="'courrierFiche.openAllMailsWithThisFolderAndService' | translate"
                      (click)="sendAdvancedSearchInfos(true, true)"></i>
                    <p>{{ courrier?.chemise?.description }}</p>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    }
    @if (courrier?.boiteArchive) {
      <div class="mt-2 ms-1">
        <div class="d-flex justify-content-between w-100">
          <div class="w-100">
            <div class="d-flex align-items-center me-4">
              <img src="./assets/img/infos_archive.svg" width="20" height="20" class="img-fluid mb-2 me-4" alt="" />
              <div class="row w-100">
                <div class="col-3">
                  <span class="fiche-point-content-info__text">{{ 'courrierFiche.archiveBox' | translate }}</span>
                  <p>{{ courrier?.boiteArchive ? courrier?.boiteArchive : '/' }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    }
    @if (courrier?.remarques) {
      <div class="ms-1 mt-2">
        <div class="d-flex justify-content-between w-100">
          <div class="w-100">
            <div class="d-flex align-items-center me-4">
              <img src="./assets/img/infos_remarques.svg" width="20" height="20" class="img-fluid mb-2 me-4" alt="" />
              <div class="row w-100">
                <div class="col-12">
                  <span class="fiche-point-content-info__text">{{ 'advancedSearch.remark' | translate }}</span>
                  <p>{{ courrier?.remarques }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    }
  </i-accordion-tab>
  @if (courrier?.natureCustomDatas?.length > 0 && courrier.nature?.natureCustomFields) {
    <i-accordion-tab [header]="'courrierFiche.complementaryDatas' | translate" [showEditBtn]="false">
      <div class="ms-1">
        <div class="d-flex justify-content-between w-100">
          <div class="w-100">
            <div class="d-flex align-items-center me-4">
              <img src="./assets/img/icon_stamp.svg" alt="img" width="20" height="20" class="img-fluid mb-2 me-4" alt="" />
              <div class="row w-100">
                <div class="col-12">
                  <app-complement-data-form
                    [readOnly]="true"
                    [natureWithComplementaryDatas]="courrier?.nature"
                    [formDataForReadonly]="courrier?.natureCustomDatas"></app-complement-data-form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </i-accordion-tab>
  }
  @if (courrier?.priseEnChargeInfo) {
    <i-accordion-tab [header]="'courrierFiche.handling' | translate" [showEditBtn]="false">
      <ng-template pTemplate="header">
        <div class="priseEnChargeDivGreen">
          <svg
            width="14px"
            height="12px"
            viewBox="0 0 14 12"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink">
            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="Medium-Copy-17" transform="translate(-1243, -675)" fill="#FFFFFF" fill-rule="nonzero">
                <g id="noun-check-id-580657" transform="translate(1243, 675)">
                  <path
                    d="M5.86280151,8.56982373 C5.86280151,7.89600697 6.02279252,7.26093405 6.30034459,6.69331884 C6.27595837,6.6170804 6.26214392,6.53631943 6.26214392,6.45060504 C6.61778976,6.12076108 7.10016973,5.61920591 7.38828057,4.84751572 C7.42197012,4.87750127 7.46003041,4.89461663 7.5010494,4.89136143 C7.73279026,4.873964 8.12169298,3.77184579 7.96298663,3.31499449 C7.90195073,3.13833349 7.81300589,3.08769856 7.72659429,3.09193866 C7.76479496,1.38416858 6.88351644,0 5.08257109,0 C3.28166182,0.000141433083 2.40008018,1.38416858 2.43829528,3.09193866 C2.35682025,3.09420173 2.27421573,3.14851551 2.21642396,3.31499449 C2.05784391,3.77199063 2.44661311,4.87398102 2.67836119,4.89136143 C2.71515089,4.89419027 2.74884081,4.88117759 2.77985314,4.85755689 C3.06501575,5.62359844 3.51568332,6.12263345 3.86892943,6.45119561 C3.86892943,7.36080659 2.9349148,7.55669829 2.01417982,7.86505572 C-0.0164891826,8.55570975 0,10.4272902 0,10.4272902 C0,10.4272902 1.16319913,12 5.08199732,12 C5.96920838,12 6.7069872,11.9168311 7.32737818,11.792362 C6.43240862,11.0063692 5.86293503,9.85488088 5.86293503,8.56988927 L5.86280151,8.56982373 Z"
                    id="Path"></path>
                  <path
                    d="M10.5,5 C8.56691501,5 7,6.56691501 7,8.5 C7,10.433085 8.56691501,12 10.5,12 C12.433085,12 14,10.433085 14,8.5 C14,6.56716471 12.433085,5 10.5,5 L10.5,5 Z M12.4804927,7.89861084 L10.9909139,9.36033001 C10.7956934,9.55192627 10.4777052,9.86697514 10.2842932,10.0605298 L10.1687776,10.1760454 C9.9753692,10.3694538 9.658922,10.3694538 9.46536737,10.1760454 L8.57468074,9.28535881 C8.38127236,9.09195043 8.35312739,8.80350551 8.51253351,8.64451675 C8.6718005,8.48552799 8.95842973,8.51548508 9.14973705,8.71098383 L9.46618425,9.03425859 C9.65750227,9.22975733 9.97282938,9.23240417 10.1669548,9.04011089 L11.9027396,7.32034265 C12.0968436,7.12791168 12.3864121,7.10101878 12.545936,7.26056402 C12.7047856,7.41955278 12.6755241,7.70703099 12.4804463,7.89862368 L12.4804927,7.89861084 Z"
                    id="Shape"></path>
                </g>
              </g>
            </g>
          </svg>
          <span class="ms-2">{{ courrier?.priseEnChargeInfo?.serviceLabel ? courrier?.priseEnChargeInfo?.serviceLabel : '/' }}</span>
        </div>
      </ng-template>
      <div class="ms-1">
        <div class="d-flex justify-content-between w-100">
          <div class="d-flex">
            <!-- Pris en charge PAR TODO back pour avoir la personne  -->
            @if (courrier?.priseEnChargeInfo?.serviceLabel) {
              <div class="d-flex align-items-center me-4">
                <img
                  src="./assets/img/infos_prisecharge.svg"
                  width="20"
                  height="20"
                  [alt]="'courrierFiche.handledBy' | translate"
                  class="img-fluid mb-2 me-4" />
                <div>
                  <span class="fiche-point-content-info__textGreen">{{ 'courrierFiche.handledBy' | translate }}</span>
                  <p>{{ courrier?.priseEnChargeInfo?.serviceLabel ? 'Service : ' + courrier?.priseEnChargeInfo?.serviceLabel : '/' }}</p>
                </div>
              </div>
            }
            @if (courrier?.priseEnChargeInfo?.demandeurContactLabel) {
              <div class="d-flex align-items-center me-4">
                @if (!courrier?.priseEnChargeInfo?.demandeurContactLabel) {
                  <img src="./assets/img/infos_prisecharge.svg" width="20" height="20" class="img-fluid mb-2 me-4" alt="" />
                }
                <div>
                  <span class="fiche-point-content-info__text">{{ 'courrierFiche.requestedBy' | translate }}</span>
                  <p>{{ courrier?.priseEnChargeInfo?.demandeurContactLabel ? courrier?.priseEnChargeInfo?.demandeurContactLabel : '/' }}</p>
                </div>
              </div>
            }
            @if (courrier?.priseEnChargeInfo?.commentaire) {
              <div class="d-flex align-items-center me-4">
                @if (!courrier?.priseEnChargeInfo?.demandeurContactLabel && !courrier?.priseEnChargeInfo?.serviceLabel) {
                  <img src="./assets/img/infos_prisecharge.svg" width="20" height="20" class="img-fluid mb-2 me-4" alt="" />
                }
                <div>
                  <span class="fiche-point-content-info__text">{{ 'courrierFiche.handlingComment' | translate }}</span>
                  <p>{{ courrier?.priseEnChargeInfo?.commentaire }}</p>
                </div>
              </div>
            }
            @if (courrier?.priseEnChargeInfo?.dateMax) {
              <div class="d-flex align-items-center me-4">
                @if (
                  !courrier?.priseEnChargeInfo?.demandeurContactLabel &&
                  !courrier?.priseEnChargeInfo?.serviceLabel &&
                  !courrier?.priseEnChargeInfo?.commentaire
                ) {
                  <img src="./assets/img/infos_prisecharge.svg" width="20" height="20" class="img-fluid mb-2 me-4" alt="" />
                }
                <div>
                  <span class="fiche-point-content-info__text">{{ 'courrierFiche.limitDate' | translate }}</span>
                  <p>{{ courrier?.priseEnChargeInfo?.dateMax | momentFormat: 'DD/MM/YYYY' }}</p>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    </i-accordion-tab>
  }
  @if (tags?.length > 0 && !hideTags) {
    <i-accordion-tab [header]="'courrierFiche.label' | translate" [showEditBtn]="false">
      <div class="ms-1">
        <div class="d-flex justify-content-between w-100">
          <div class="d-flex wrapChips">
            <div class="d-flex align-items-center me-4">
              <img src="./assets/img/infos_tag.svg" width="20" height="20" class="img-fluid mb-2 me-4" alt="" />
            </div>
            @for (item of tagsCourrier; track item; let i = $index) {
              <div class="mb-2">
                @if (readonly) {
                  <p-chip styleClass="custom-chip-basic" label="{{ item.description }}" [removable]="false"></p-chip>
                }
                @if (!readonly) {
                  <p-chip styleClass="noBG">
                    <div class="custom-chip-basic">
                      <div class="custom-chip-basic__customText">{{ item.description }}</div>
                      @if (item?.canUncheck) {
                        <i class="bi bi-x-circle cursor--pointer ms-2" (click)="deleteTags(item)"></i>
                      }
                    </div>
                  </p-chip>
                }
              </div>
            }
            @if (!readonly) {
              <div class="addEtiquette" (click)="displayEtiquetteAdd = true">
                <span>{{ 'courrierFiche.addLabel' | translate }} ...</span>
              </div>
            }
          </div>
        </div>
        @if (displayEtiquetteAdd) {
          <div class="row me-2 mt-3 mb-4">
            <div class="col-md-8">
              <div>
                @if (rightManagement?.menu?.mails) {
                  <i class="bi bi-plus-circle-fill greenIcon onCursor mb-2" (click)="createTag()" [pTooltip]="'tagsInfos.createATag' | translate"></i>
                }
              </div>
              <p-multiSelect
                appendTo="body"
                [options]="tagsAllowedToBeAdded | sort: 'ordreAffichage' : 'ASC'"
                [placeholder]="'courrierFiche.selectLabel' | translate"
                [(ngModel)]="tagsModel"
                [selectedItemsLabel]="'tagsInfos.xTagsSelected' | translate">
              </p-multiSelect>
            </div>
            @if (!readonly) {
              <div class="col-md-4 d-flex justify-content-end">
                @if (tagsModel.length <= 1) {
                  <i-button
                    [text]="'courrierFiche.linkLabelToMail' | translate"
                    id="btnAddTagToMail"
                    styleClass="green"
                    (click)="addTags(tagsModel)"></i-button>
                }
                @if (tagsModel.length > 1) {
                  <i-button
                    [text]="'courrierFiche.linkLabelsToMail' | translate"
                    id="btnAddTagToMail"
                    styleClass="green"
                    (click)="addTags(tagsModel)"></i-button>
                }
              </div>
            }
          </div>
        }
      </div>
    </i-accordion-tab>
  }
  @if (courrier?.workflowForInfos) {
    <i-accordion-tab [header]="'Flux'" [showEditBtn]="false" (selectEmitter)="onOpenFlowTab($event)">
      <div class="ms-1">
        @for (flow of courrier?.workflowForInfosArray; track flow; let i = $index) {
          @if (i > 0) {
            <hr />
          }
          <div class="d-flex justify-content-between w-100">
            <div class="w-100">
              <div class="d-flex align-items-center">
                <div class="row w-100">
                  @if (flow?.definitionVersion) {
                    <div class="col-4">
                      <span class="fiche-point-content-info__text"> {{ 'courrierFiche.flow' | translate }} </span>
                      <p [pTooltip]="getTooltipFlow(i)" tooltipPosition="bottom">{{ flow?.definitionVersion?.name }}</p>
                    </div>
                  }
                  @if (flow?.subStatus) {
                    <div class="col-4">
                      <span class="fiche-point-content-info__text">{{ 'courrierFiche.flowStatus' | translate }}</span>
                      <!-- ! Si hasFaultedState alors on doit absolument afficher le flux en erreur car ELSA ne renvoie "erreur" que quand le flux est terminé en erreur or ici il peut être relancé -->
                      @if (flow.hasFaultedState) {
                        <p class="status-red">{{ 'Faulted' | translate }}</p>
                      } @else {
                        <p
                          [ngClass]="{
                            'status-red': flow.subStatus === 'Cancelled' || flow.subStatus === 'Faulted',
                            'status-green': flow.subStatus === 'Finished',
                            'status-orange': flow.subStatus === 'Pending' || flow.subStatus === 'Executing' || flow.subStatus === 'Suspended',
                          }">
                          {{ flow.subStatus | translate }}
                        </p>
                      }
                    </div>
                  }
                  @if (displayFlowButtons && !readonly) {
                    <div class="d-flex justify-content-end align-items-center col-4">
                      @for (button of flowButtons; track button; let i = $index) {
                        <i
                          [class]="button.icon"
                          [pTooltip]="button.label"
                          (click)="button.click(flow)"
                          [ngClass]="{ 'icon--medium ms-5 cursor--pointer': true }"></i>
                      }
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    </i-accordion-tab>
  }
</i-accordion>
